import 'simplebar-react/dist/simplebar.min.css';

// react
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// basics
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SignedProvider } from "./contexts/client";
import { JWTProvider } from "./contexts/auth";
// import * as serviceWorker from './serviceWorker';

//==================================================

ReactDOM.render(
  <HelmetProvider>
    <JWTProvider>
      <SignedProvider>
        <BrowserRouter basename={"/"}>
          <App />
        </BrowserRouter>
      </SignedProvider>
    </JWTProvider>
  </HelmetProvider>,
  document.getElementById("root")
);

reportWebVitals();
